// extracted by mini-css-extract-plugin
export default {"root":"IconAnonym_root__O5owH"};